// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._QvsBa {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-2, 16px);
  padding: var(--spacing-2, 16px);
}

.kcMcb5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}

.kcMcb5 .pATmA3 {
  width: 48px;
  height: 48px;
  color: var(--status-error, #dc0a0a);
}

.AVi48c {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-180, 180%);
  color: var(--text-neutral-dark, #1f1f1f);
  text-align: center;
  max-width: 100%;
}

.n7lN4v {
  display: flex;
  gap: var(--spacing-1-5, 12px);
  margin-top: var(--spacing-1, 8px);
  width: 100%;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ErrorModal/ErrorModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,iEAAiE;EACjE,mDAAmD;EACnD,4CAA4C;EAC5C,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iCAAiC;EACjC,WAAW;EACX,uBAAuB;AACzB","sourcesContent":[".errorModalContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-2, 16px);\n  padding: var(--spacing-2, 16px);\n}\n\n.errorModalIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n}\n\n.errorModalIcon .icon {\n  width: 48px;\n  height: 48px;\n  color: var(--status-error, #dc0a0a);\n}\n\n.errorModalMessage {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-180, 180%);\n  color: var(--text-neutral-dark, #1f1f1f);\n  text-align: center;\n  max-width: 100%;\n}\n\n.errorModalActions {\n  display: flex;\n  gap: var(--spacing-1-5, 12px);\n  margin-top: var(--spacing-1, 8px);\n  width: 100%;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorModalContent": `_QvsBa`,
	"errorModalIcon": `kcMcb5`,
	"icon": `pATmA3`,
	"errorModalMessage": `AVi48c`,
	"errorModalActions": `n7lN4v`
};
module.exports = ___CSS_LOADER_EXPORT___;
